module.exports = __webpack_public_path__ + "images/vpz_smallb98751da6a9ed8d3b75dfb9ef272c7a7.png";